type CreateComprobanteFormDataInput = {
  comprobante: Blob;
  concepto: string;
  monto: string;
  vetFormId: string;
};

export const createComprobanteFormData = (
  values: CreateComprobanteFormDataInput,
): FormData => {
  const fd = new FormData();

  const extension = values.comprobante.type === 'application/pdf' ? 'pdf' : 'jpg';
  const fileName = `comprobante.${extension}`;

  fd.append('comprobante', values.comprobante, fileName);
  fd.append('concepto', values.concepto.trim());
  fd.append('monto', values.monto);
  fd.append('vetFormId', values.vetFormId);

  return fd;
};
